import React, { Component } from 'react';
import './deepweb.css';
import companyLogo from './../../../../../assets/Images/regex.png';
import { Consumer } from "../../../../Context";
import Button from '@mui/material/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faCheckSquare } from '@fortawesome/free-solid-svg-icons'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
export default class DeepWeb extends Component {


    render() {


        return (
            <Consumer>
                {
                    c => {

                        let theSubjectsAndSubTopicsCompletedIndex = c.subjectsAndSubTopicsCompletedIndex

                        return (
                            <div className="paper DeepWeb" >
                                <h4></h4>
                                <div className="img-div"><img src={companyLogo} /></div>

                                <p>
                                    <b style={{ fontSize: "17pt", color: "#15aebd" }}>הרשת העמוקה (Deep Web)</b>
                                </p>
                                <p className='c9'>

                                    <span className='c1 c14'>הרשת העמוקה</span>
                                    <span className='c2 c1'>&nbsp;, היא מורכבת מכל דבר שלא ממופה על ידי מנועי חיפוש!</span>
                                </p>

                                <p className="c5"><span className="c0"></span></p>
                                <p className='c9'>
                                    <span className='c2 c1'>שאלה :</span>
                                </p>
                                <p className="c9" dir="rtl">
                                    <span className="c1 c13 c15">
                                        מהי כמות המידע באחוזים שנגישה לרוב המשתמשים?
                                    </span>
                                </p>
                                <p className="c5"><span className="c0"></span></p>
                                <p className="c9" >
                                    <span className="c4">
                                        אם רוצים להבין את הגודל, משל מצויין הוא מרחב האינטרנט שגלוי לכם, הוא כמו
                                    </span>
                                    <span className="c1">קצה של קרחון</span><span class="c0">!</span>
                                </p>

                                <p className="c9">
                                    <span className="c4">
                                        לרוב המשתמשים הגולשים ברשת העולמית (World Wide Web)
                                        יש רק גישה ל- 4 אחוז מהמידע הקיים ברשת!
                                    </span>
                                </p>
                                <p className="c9">
                                    <span className="c4">
                                        היתר, עמוק מתחת לפני השטח, המכונה<span style={{ display: "inline", fontSize: "17pt", color: "blue" }}>"הרשת העמוקה"</span>
                                    </span>
                                </p>
                                <p className="c9">
                                    <span className="c4">
                                        אז הרשת העמוקה היא מאגר מידע ענק ולא נגיש, לדוגמה:
                                    </span>
                                </p>
                                <p className='c9 list-items'>
                                    <b></b>
                                    <span style={{ fontSize: '17pt' }}>מאגרים סגורים של בנקים</span>
                                    <span style={{ fontSize: '17pt' }}>ממשלות</span>
                                    <span style={{ fontSize: '17pt' }}>תאגידים</span>
                                    <span style={{ fontSize: '17pt' }}>מסדי נתונים של מכללות ואונברסיטאות.</span>
                                </p>
                                <p className="c9">
                                    <span className="c4 c13">
                                        בתוך הרשת הזאת, יש את האזור האפל!
                                        האינטרנט הרגיל לעומתו ה דארקנט!
                                        מערכת מחתרתית של אתרים שאינם ניתנים למעקב! 🌑
                                    </span>
                                </p>
                                
                                <Button variant="contained" onClick={(e) => {
                                    // the first index is the array of objects in state.subjectsAndSubTopics, 
                                    // the second index is the index in the completed array in the state.subjectsAndSubTopics index
                                    let subjectsAndSubTopicsIndex = 16
                                    let completedIndex = 1
                                    let subjectsAndSubTopicsCompletedIndex = 1
                                    let obj = c.subjectsAndSubTopics[subjectsAndSubTopicsIndex]
                                    obj.completed[subjectsAndSubTopicsCompletedIndex] = faCheckSquare
                                    c.actions.setCompletedSubTopic(subjectsAndSubTopicsIndex, completedIndex)

                                }}>Next  <FontAwesomeIcon icon={faArrowRight} style={{ fontSize: '13pt', paddingLeft: '5px' }} /></Button>

                            </div>
                        )
                    }
                }
            </Consumer>)
    }

}
